import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

type EditNoteProps = {
  visitnote: string;
  id: string;
  reserveid: string;
  editNote: string;
  onSave: () => void;
  onEditNoteClick: (id: string) => void;
  onCancel: () => void;
};

const EditNote: React.FC<EditNoteProps> = (props) => {
  const [note, setNote] = useState(props.visitnote);

  const handleEditNote = () => {
    props.onEditNoteClick(props.reserveid);
  };

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setNote(event.target.value);
  };

  const handleSave = () => {
    try {
      const token = getToken();
      postAPI(`/reserve/save-visit-note?token=${token}`, {
        note: note,
        patientid: props.id,
        id: props.reserveid,
      }).then((res) => {
        if (res.code === 200) {
          props.onSave();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Escape') {
      props.onCancel()
    }
    if (event.key === 'Enter') {
      handleSave()
    }
  };

  return (
    <>
      {props.editNote !== props.reserveid ? (
        <>
          {props.visitnote}{' '}
          <Box
            component={'img'}
            src='/images/icons/ic-edit.svg'
            alt='icon edit'
            sx={{
              width: '20px',
              height: '20px',
            }}
            onClick={() => handleEditNote()}
          ></Box>
        </>
      ) : (
        <TextField
          autoFocus
          margin='dense'
          id='note'
          variant='standard'
          value={note || ''}
          onChange={(event) => handleChange(event)}
          onKeyDown={(event) => handleKeyDown(event)}
          onBlur={handleSave}
          sx={{ width: '150px' }}
        />
      )}
    </>
  );
};

export default EditNote;
